import React, {useState} from 'react';
import logo from "../../images/Logo_title.png"
import MenuItem from "../../_components/header/MenuItem";
import "./Header.sass"
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import {setEmpty as clearGroup} from "../../_actions/group/groupReducer";
import {clearHWState} from "../../_actions/student/hw/hwReducer";
import {clearGameState} from "../../_actions/game/gameReduce";
import {useNavigate} from "react-router";
import {logout} from "../../_actions/auth/authService";
import {IDLE, LOADING} from "../../common/statuses";
import SettingsIcon from "@mui/icons-material/Settings";
import {Badge, IconButton} from "@mui/material";
import {Mail, Menu} from "@mui/icons-material";
import _ from "lodash";
import {clearNotificationState} from "../../_actions/notification/notificationReducer";
import {HOME, MAIN, PERSONAL_SETTINGS} from "../../common/links";
import {MobileMenu} from "./MobileMenu";

const LoginButton = () => {
    const {current: user, status} = useSelector(state => state.auth)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        navigate(MAIN);
        dispatch(logout());
        dispatch(clearGroup());
        dispatch(clearHWState());
        dispatch(clearGameState());
        dispatch(clearNotificationState())
    }

    if (status === IDLE || status === LOADING) {
        return <></>
    }

    if (user) {
        return <div className="login-button-wrapper">
            <div className="login-button-name">
                {`${user.lastName} ${user.firstName}`}
            </div>
            <Link to={HOME}>
                <PersonIcon/> Профиль
            </Link>
            <Link to={PERSONAL_SETTINGS}>
                <SettingsIcon/> Настройки
            </Link>
            <Link to={MAIN} onClick={handleLogout}>
                <LogoutIcon/> Выйти
            </Link>
        </div>
    } else {
        return <div className="header-login">
            <Link to={"login"}>
                <div className="login-button-login">
                    Войти
                </div>
            </Link>
        </div>
    }
}

export function Header({onNotificationClick, countNotifications}) {
    const [openMenu, setOpenMenu] = useState(false);

    const {current: user} = useSelector(state => state.auth)

    return (
        <div style={openMenu ? {zIndex: 1} : {}} className="header-wrapper">
            <div className="header-content">
                <div className="header-left">
                    <div className="header-menu-button">
                        <IconButton aria-label="menu"
                                    onClick={() => setOpenMenu(!openMenu)}
                                    color="primary">
                            <Menu/>
                        </IconButton>
                    </div>
                    <div className="header-logo">
                        <Link to={MAIN}>
                            <img src={logo} alt="Главная"/>
                        </Link>
                    </div>
                    {
                        !_.isEmpty(user) && <div className="header-items-panel">
                            <MenuItem url="courses" name="Курсы"/>
                            <MenuItem url="teachers" name="Методисты"/>
                            <MenuItem url="collaboration" name="Сотрудничество"/>
                            <MenuItem url="about" name="О нас"/>
                        </div>
                    }
                </div>
                <div className="header-right">
                    {
                        !_.isEmpty(user) && <div className="header-right-notification" onClick={onNotificationClick}>
                            <Badge badgeContent={countNotifications} color="error">
                                <Mail color="action"/>
                            </Badge>
                        </div>
                    }
                    <LoginButton/>
                </div>
            </div>
            <MobileMenu  show={openMenu}
                         onHide={() => setOpenMenu(false)}/>
        </div>
    )
}
